import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectIsReservationOnly } from '../../redux/selector/system'

const RESERVATION_ONLY_PATHS = [
	'/settings',
	'/settings/restaurant',
	'/settings/program',
	'/settings/program/users',
	'/help',
	'/invoices',
]

const RESERVATION_ONLY_SECTIONS = [
	'/settings/restaurant/areas',
	'/settings/program/users/all',
]

const isReservationOnlyPath = (pathname) =>
	RESERVATION_ONLY_PATHS.includes(pathname)
	|| RESERVATION_ONLY_SECTIONS.some(section => pathname === section || pathname.startsWith(`${section}/`))

const RequireReservationScope = () => {
	const isReservationOnly = useSelector(selectIsReservationOnly)
	const { pathname } = useLocation()
	const navigate = useNavigate()

	useEffect(() => {
		if (isReservationOnly && !isReservationOnlyPath(pathname)) {
			navigate('/settings', { replace: true })
		}
	}, [isReservationOnly, pathname, navigate])

	return null
}

RequireReservationScope.displayName = 'RequireReservationScope'
export default RequireReservationScope
